import React, {Fragment, useContext, useEffect, useState} from 'react'

import Box from '@mui/material/Box';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import { PolygonForm } from './styleConfig/polygonForm';
import { LineForm } from './styleConfig/lineForm';
import {useTreeViewApiRef} from "@mui/x-tree-view";
import config from "#src/configs/xplanStyles";
import {XplanStylerContext} from "#src/context/XplanStylerContext";

export const XplanStylerPage = () => {

  const [newConfig, setNewConfig] = useState(config);
  const [activeConfig, setActiveConfig] = useState(null);
  const apiRef = useTreeViewApiRef();


  /* todo: && 111 on line 52 seams to be wrong ? */
  return (
      <XplanStylerContext.Provider value={{activeConfig, newConfig, setNewConfig}}>
        <div className="mx-auto max-w-7xl bg-gray-100 lg:px-4">
          <h2 className="text-xl my-8 flex ml-4 font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
            XPLAN Darstellung
          </h2>
          <div className="grid gap-x-8">
            <div className="flex flex-1 overflow-hidden py-2">
              <div className='overflow-y-auto overflow-x-hidden messagingList px-4 mr-2 '>
                <div className='overflow-y-auto overflow-x-hidden w-md'>
                  <div className={"font-bold mb-4"}> Ebenen</div>
                  <Box sx={{ minHeight: 352, minWidth: 250 }}>
                    <SimpleTreeView apiRef={apiRef} >
                      {Object.keys(config).map((key) => (
                          <TreeItem  itemId={config?.[key]?.id} label={config?.[key]?.name} key={config?.[key]?.id}>
                            {Object.keys(config?.[key]?.rules)?.map((rule) => (
                                <TreeItem  onClick={() => setActiveConfig(config?.[key]?.rules?.[rule])} itemId={config?.[key]?.rules+"-"+rule} label={config?.[key]?.rules?.[rule]?.name + " ("+config?.[key]?.rules?.[rule]?.type+")"} key={config?.[key]?.rules+"-"+rule}/>
                            ))}
                          </TreeItem>
                      ))}
                    </SimpleTreeView>
                  </Box>
                </div>
              </div>
              {activeConfig && (
                  <>
                    <div className="overflow-y-auto overflow-x-hidden messagingList max-w-md w-md  px-4 ">
                      <div className='flex-1 '>
                        <div className={"font-bold mb-4"}>Darstellung</div>
                        {(activeConfig?.type === "Polygon") && <PolygonForm/>}
                        {(activeConfig?.type === "LineString") && <LineForm/>}
                        {(activeConfig?.type === "Point") && 111}
                      </div>
                    </div>
                  </>
              )}
            </div>
          </div>
        </div>
      </XplanStylerContext.Provider>
  );
}
